import type { EmptyStateProps } from '@/components/ui/empty';

type EmptyStateConfig = Pick<EmptyStateProps, 'title' | 'description' | 'variant'>;

export const EMPTY_STATES = {
  'no-posts': {
    title: 'No posts yet',
    description: 'Start creating content to see it here.',
  },
  'analytics-connect': {
    title: 'Connect a platform to see analytics',
    description:
      'Link Instagram, TikTok, Facebook, or LinkedIn to start tracking your content performance.',
  },
  'analytics-chart': {
    title: 'No data available',
    description: 'No data available for this period.',
    variant: 'compact',
  },
  'analytics-disconnected': {
    title: 'Platform disconnected',
    description: 'Reconnect your account to see analytics.',
  },
  products: {
    title: 'No products yet',
    description: 'Connect your store to feature products in your content.',
    variant: 'card',
  },
  templates: {
    title: 'No templates found',
    description: 'Create reusable templates for your content.',
    variant: 'card',
  },
  'brand-voice': {
    title: 'No brand voice yet',
    description: 'Set up your brand voice to personalize every post.',
    variant: 'card',
  },
  competitors: {
    title: 'No competitors added',
    description: 'Add competitors to help the AI understand your market.',
    variant: 'card',
  },
  bookmarks: {
    title: 'No bookmarks yet',
    description: 'Save posts from your feed to reference later.',
  },
  inspiration: {
    title: 'No inspiration posts',
    description: 'Add competitors to see their content strategy.',
  },
  'content-ideas': {
    title: 'No ideas yet',
    description: 'Generate content ideas based on trending topics.',
  },
  'no-results': {
    title: 'No results found',
    description: 'Try adjusting your search or filters.',
  },
  'no-items': {
    title: 'No items found',
    description: 'Try adjusting your search terms.',
    variant: 'inline',
  },
  'auto-responder': {
    title: 'No activity yet',
    description: 'Auto-responder activity will appear here.',
  },
  marketplace: {
    title: 'No items available',
    description: 'Check back later for new marketplace items.',
  },
  upload: {
    title: 'No files uploaded',
    description: 'Drag and drop files or click to upload.',
  },
  variations: {
    title: 'No variations yet',
    description: 'Generate variations of your content for different platforms.',
  },
  assets: {
    title: 'No assets yet',
    description: 'Upload or generate creative assets.',
  },
} as const satisfies Record<string, EmptyStateConfig>;

export type EmptyStateId = keyof typeof EMPTY_STATES;
